module.exports = __webpack_public_path__ + "webStatic/img/load-err.ca5e0598.png";